<template>
  <div class="container">
    <span class="landscape_error" v-show="$store.getters['app/overlays'].show_landscape_error">
      <p id="text_error">Please set device to landscape</p>
    </span>

    <img draggable="false" @click="goToHome()" class="clickable" id="quit_btn" src="./assets/images/Asset 74.png" alt="">
    <img class="background_image" src="./assets/images/Asset 75.png" alt="">

    <span v-show="$store.getters['app/overlays'].show_start_menu_overlay">
      <img id="logo" src="./assets/images/Asset 49.png" alt="">
      <img id="closet" src="./assets/images/Asset 72.png" alt="">

      <span v-for="(item) in items" :key="item.id">
        <img draggable="false" @click="goToStartPage(item)" v-if="item.image == 83" id="main_image_83" class="clickable" src="./assets/images/Asset 83.png" alt="">
        <img draggable="false" @click="goToStartPage(item)" v-if="item.image == 111" id="main_image_111" class="clickable" src="./assets/images/Asset 111.png" alt="">
        <img draggable="false" @click="goToStartPage(item)" v-if="item.image == 128" id="main_image_128" class="clickable" src="./assets/images/Asset 128.png" alt="">
        <img draggable="false" @click="goToStartPage(item)" v-if="item.image == 107" id="main_image_107" class="clickable" src="./assets/images/Asset 107.png" alt="">
        <img draggable="false" @click="goToStartPage(item)" v-if="item.image == 130" id="main_image_130" class="clickable" src="./assets/images/Asset 130.png" alt="">
        <img draggable="false" @click="goToStartPage(item)" v-if="item.image == 112" id="main_image_112" class="clickable" src="./assets/images/Asset 112.png" alt="">
        <img draggable="false" @click="goToStartPage(item)" v-if="item.image == 76" id="main_image_76" class="clickable" src="./assets/images/Asset 76.png" alt="">
        <img draggable="false" @click="goToStartPage(item)" v-if="item.image == 109" id="main_image_109" class="clickable" src="./assets/images/Asset 109.png" alt="">
        <img draggable="false" @click="goToStartPage(item)" v-if="item.image == 102" id="main_image_102" class="clickable" src="./assets/images/Asset 102.png" alt="">
        <img draggable="false" @click="goToStartPage(item)" v-if="item.image == 1" id="main_image_1" class="clickable" src="./assets/images/Asset 1.png" alt="">
        <img draggable="false" @click="goToStartPage(item)" v-if="item.image == 129" id="main_image_129" class="clickable" src="./assets/images/Asset 129.png" alt="">
        <img draggable="false" @click="goToStartPage(item)" v-if="item.image == 113" id="main_image_113" class="clickable" src="./assets/images/Asset 113.png" alt="">
        <img draggable="false" @click="goToStartPage(item)" v-if="item.image == 82" id="main_image_82" class="clickable" src="./assets/images/Asset 82.png" alt="">
        <img draggable="false" @click="goToStartPage(item)" v-if="item.image == 81" id="main_image_81" class="clickable" src="./assets/images/Asset 81.png" alt="">
        <img draggable="false" @click="goToStartPage(item)" v-if="item.image == 100" id="main_image_100" class="clickable" src="./assets/images/Asset 100.png" alt="">
        <img draggable="false" @click="goToStartPage(item)" v-if="item.image == 126" id="main_image_126" class="clickable" src="./assets/images/Asset 126.png" alt="">
        <img draggable="false" @click="goToStartPage(item)" v-if="item.image == 49" id="main_image_49" class="clickable" src="./assets/images/49.jpeg" alt="">
        <img draggable="false" @click="goToStartPage(item)" v-if="item.image == 77" id="main_image_77" class="clickable" src="./assets/images/Asset 77.png" alt="">
        <img draggable="false" @click="goToStartPage(item)" v-if="item.image == 78" id="main_image_78" class="clickable" src="./assets/images/Asset 78.png" alt="">
        <img draggable="false" @click="goToStartPage(item)" v-if="item.image == 79" id="main_image_79" class="clickable" src="./assets/images/Asset 79.png" alt="">
        <img draggable="false" @click="goToStartPage(item)" v-if="item.image == 108" id="main_image_108" class="clickable" src="./assets/images/Asset 108.png" alt="">
        <img draggable="false" @click="goToStartPage(item)" v-if="item.image == 80" id="main_image_80" class="clickable" src="./assets/images/Asset 80.png" alt="">
      </span>
    </span>
    
    <router-view/>
  </div>

</template>

<script>

export default {
  name: 'App',

  mounted() {
    this.checkLandscape()
  },

  created() {
    window.addEventListener("resize", this.checkLandscape);
  },
  destroyed() {
    window.removeEventListener("resize", this.checkLandscape);
  },

  data() {
    return {
      items: [
        {
          id: 1,
          name: "Hennah Draaibaar",
          image: 83,
          type: 'open',
          person_image: '',
          text: "Sranan krakti Hennah Draaibaar is geboren in Suriname en opgegroeid in Nederland. In 1998 besloot zij zich voorgoed in Suriname te vestigen. Vanaf 1998 werkte zij als correspondent voor de NOS en mocht zij het nieuws verslaan voor radio en TV. In 2002 is zij samen met Eddy Wijngaarde begonnen met The Back Lot, een organisatie die werkt aan de ontwikkeling van jongeren door gebruik te maken van film, kunst en cultuur. The Back Lot staat bekend in Suriname voor het bouwen van TBL Cinemas, het opzetten van het 10 Minuten Jeugd Journaal (een programma waarin kinderen een stem hebben) en Krutu (jongerendebat programma). Maar ook voor het organiseren van filmfestivals, het opzetten van awareness programma's over kwik, plastic en ons milieu. Omdat zij beiden geloven in een betere wereld voor ons allemaal zetten zij zich als bedrijf graag in voor projecten die een impact hebben. Hennah gelooft dat we allemaal kleine handelingen kunnen doen om het verschil te maken in de levens van mensen om ons heen."
        },
        {
          id: 2,
          name: "Cynthia McLeod",
          image: 111,
          type: 'open',
          person_image: '',
          text: "Sranan Krakti Cynthia Mc Leod is geboren op 4 okt 1936 te Paramaribo. Cynthia heeft altijd bijzonder veel belangstelling gehad voor de Surinaamse geschiedenis. In haar jeugd had zij altijd het gevoel dat ze te weinig leerde op school over de eigen geschiedenis. Reeds als kind heeft zij geprobeerd dit aan te vullen door zelf alles te bestuderen over de Surinaamse geschiedenis. Als lerares aan het Lyceum werd zij dan ook de vraagbaak van de leerlingen aan wie zij veel vertelde en die haar zeer stimuleerden om te schrijven. Het gedicht van Corly Verlooghen was de inspiratie voor de titel van haar boek. 'Hoe duur was de suiker' verscheen in 1987 en was meteen een hit. Dat kwam vooral omdat dit de eerste keer was dat de Surinamers op een leuke manier konden lezen over hun eigen geschiedenis en achtergrond. De behoefte daaraan bestond bij vrijwel alle Surinamers. Haar boeken zijn vertaald naar het Engels en Duits en Italiaans. De Zweedse en Portugese vertaling zijn in de maak."
        },
        {
          id: 3,
          name: "Boni",
          image: 128,
          type: 'closed',
          person_image: '',
          text: "Sranan Krakti Boni (ca. 1730 – 19 februari 1793), was één van de grootste vrijheidsstrijders in Suriname. In 1765 volgde hij Asikan Sylvester op als leider van de groep die bekend zou worden onder zijn naam: 'Boni's' (nu: Aluku stam). Hij trainde andere weggelopen tot slaaf gemaakten tot geduchte tegenstanders van de kolonisten. Talrijke aanvallen voerden ze uit op plantages in het oosten van Suriname, vooral in het gebied van de Cotticarivier. Boni en zijn krijgers opereerden vanuit een groot fort met een vier meter hoge muur in de kuststreek van Commewijne. Dit fort kennen wij nu als Fort Boekoe. Het fort was omringd door moeras en voorzien van geweren en een kanon. Door de ligging van het fort, was het nagenoeg onvindbaar en onbereikbaar voor de troepen van het gouvernement. Op 20 september 1772 werd het fort veroverd en vernietigd, maar Boni ontsnapte naar het oosten en trok over de Marowijne, de grensrivier met Frans-Guyana. Nog 20 jaar lang ging Boni door met zijn strijd tegen de slavendrijvers. Uiteindelijk werd hij na te zijn verraden op 19 februari 1793 gedood"
        },
        {
          id: 4,
          name: "Marlene Lie-A-Ling",
          image: 107,
          type: 'open',
          person_image: '',
          text: "Sranan Krakti Marlène Lie-A-Ling, begon vanaf haar 5de jaar met balletlessen inhet Cultureel Centrum Suriname (C.C.S.). Zij vertolkte vaak een hoofdrol in diverseballetopvoeringen. In 1968 vertrok ze naar Nederland voor verdere studie en keerde in 1971terug als danseres en danslerares in Klassiek Ballet, Moderne en Karakter dans.Sindsdien verzorgt Marlène balletlessen in ons land. Ze is medeoprichter en primaballerina van het Nationaal Ballet Suriname geweest tot en met 1982. Marlène Lie-A-Lingdoethet allemaal voor de Surinaamse jeugd; dat is altijd haar drijfveer geweest. “Dans isbelangrijk,” zegt zij altijd, “want het leven is beweging. Het begint allemaal met het ritme vande harteklop. Dat is de oer-beweging, de oer-dans.” Dans is de passie vanMarlène en spitzen geven haar ondanks het ongemak dat ze bezorgen het gevoel dat je zweeft."
        },
        {
          id: 5,
          name: "Jules Anthony Chin A Foeng",
          image: 130,
          type: 'open',
          person_image: '',
          text: "Sranan krakti Jules Anthony Chin A Foeng (Paramaribo, 20 februari 1944 – 28 juli 1983) was een Surinaamse kunstenaar, die schreef onder het pseudoniem Juanchi. Zijn kunstwerken signeerde hij als CHIN, waarvan de \"N\" omgekeerd geschreven was. Jules Chin richtte in de jaren 60 de eerste Academie voor Beeldende Kunsten in Suriname op onder de naam NIKK, Nationaal Instituut voor Kunst en Cultuur. Hij was keramist, tekenaar, beeldhouwer, schilder, maar ook docent aan de Opleiding voor Leraren in Suriname en aan de Academie voor Beeldende Kunsten. In 1976 behaalde hij als enige Surinamer ooit zijn Master Of Arts graad aan de New York University in De Verenigde Staten van Amerika. Hij studeerde af met de surrealistische stijl, die hij bij terugkeer in Suriname introduceerde op de Academie. Beeldende vorming op school is een van de vele boeken die hij schreef."
        },
        {
          id: 6,
          name: "Sophie Redmond",
          image: 112,
          type: 'open',
          person_image: '',
          text: "Sranan krakti Jeanne Sophie Everdine Redmond geboren in Paramaribo op 14 januari 1907, leefde tot 18 september 1955. Na de lagere school, de MULO en de hogere burgerschool met goed gevolg te hebben doorlopen, wilde ze in 1925 ingeschreven worden op de Geneeskundige School. De directeur van de school weigerde haar aanvankelijk in te schrijven. Maar Redmond zette door, en ondanks alle discriminatie die zij tijdens haar studie ondervond, studeerde ze in 1935 af. Vervolgens vestigde zij zich als particulier huisarts in Paramaribo. Ze behandelde arme patiënten dikwijls gratis, en gaf ook adviezen over huwelijks- en financiële problemen. Na de Tweede Wereldoorlog werd Redmond ook politiek actief. Ze ontpopte zich steeds meer als voorvechtster van de Surinaamse cultuur; ging gekleed in de traditionele koto, weigerde import voedsel te eten, en streefde naar wetenschappelijk onderzoek over de werking van Surinaamse kruiden. In 1950 deed ze mee aan de verkiezingen als onafhankelijk kandidaat, maar ze behaalde geen zetel. Dr. Sophie Redmond was niet alleen goed als arts maar elke dag bespeelde ze in haar vrije tijd de viool."
        },
        {
          id: 7,
          name: "Erwin de vries",
          image: 76,
          type: 'open',
          person_image: '',
          text: "Sranan Krakti Erwin de Vries was een beeldend kunstenaar. Erwin Jules de Vries werd geboren in Paramaribo, Suriname op 21 december 1929. Toen Erwin de Vries 18 jaar was stuurde zijn vader hem naar Nederland om te gaan studeren zodat hij tekenleraar kon worden. Hij bleef in Nederland wonen en werken tot zijn 54ste. Daarna kwam hij weer in Suriname wonen, tot aan zijn dood in 2018. In zijn schilderijen zijn veel verschillende kleuren en vormen te zien. Erwin gebruikte vaak de kleuren rood, blauw, geel en groen. Hij schilderde meestal naakte vrouwen, soms ook bloemen, paarden en portretten (geschilderde 'pasfoto's' van mensen). Hij heeft hele grote beelden gemaakt, zoals het Nationaal Slavernijmonument dat in Nederland in het Oosterpark staat. Ook in Paramaribo zien we standbeelden van deze kunstenaar van belangrijke politici zoals Jagernath Lachmon. Erwin de Vries werd 88 jaar oud. De volgende spreuk deelde hij graag: 'If you can dream it, you can do it!' waarmee hij bedoelde dat waar je van droomt, werkelijkheid kan worden. Maar daarbij zei hij ook altijd dat je er dan wel hard voor moet werken."
        },
        {
          id: 8,
          name: "Mavis Noordwijk",
          image: 109,
          type: 'closed',
          person_image: '',
          text: "Sranan krakti Mavis Noordwijk associeert zichzelf graag met een zangvogel. In muziek en zingen was zij reeds van jongs af geïnteresseerd. Het eerste muziekinstrument dat zij leerde bespelen is de sopraan blokfluit. Zij werd geïnspireerd door haar muziekdocenten. Mavis Noordwijk is tussen 1975 en 2006 actief geweest als koordirigent. Zij heeft zich ook intensief bezig gehouden met de training muzikale vorming voor ervaren leerkrachten van de Basisschool. Mavis zette tevens een cursus op voor muziek, dans en drama, mede verzorgd door Liesbeth Peroti. Hier werden leerkrachten getraind in het samenstellen van mini- musicals, geënt op de actuele situatie en de Surinaamse werkelijkheid. De slogan was: \"Met Muziek Meer Mens!\" Hierbij werd de gehele school betrokken, waardoor er best sprake was van een culturele happening. Cultureel, als vocalist, voornamelijk klassiek, met begeleiding op piano, orgel of gitaar, maar ook folkloristisch, Mavis haar bijdrage is onomstotelijk muziekeducatie."
        },
        {
          id: 9,
          name: "Wilgo Baarn",
          image: 102,
          type: 'closed',
          person_image: '',
          text: "Sranan Krakti Wilgo Baarn (1946-2017) was een Surinaamse regisseur, acteur, komiek, schrijver, zanger, danser en drummer. Vanaf de jaren '80 was Wilgo Baarn betrokken bij de culturele organisatie NAKS daar was hij dé man. Hij beschouwde zichzelf als een leerling (“een kweek”) van Eugene Drenthe, een Surinaams toneelschrijver, toneelregisseur en dichter die ook actief was bij NAKS. Volgens Wilgo Baarn hield NAKS zich met twee vormen van theater bezig: het naturalistisch theater (volkstoneel) en het ceremonieel theater. \"Dat laatste was vroeger meer folklore, maar het is in de loop der jaren aangevuld en uitgebouwd met religie en met rituelen uit diverse andere culturen van Suriname.\" legde hij uit."
        },
        {
          id: 10,
          name: "Elfriede Baarn Dijksteel",
          image: 1,
          type: 'open',
          person_image: '',
          text: "Sranan krakti Elfriede Josefiene Maria Baarn-Dijksteel (Paramaribo, 19 augustus 1947 - 1 februari 2010), bekend als Kulturu Mama wordt door familie en vrienden uit haar vroege jeugd, vooral omschreven als een stil en ook teruggetrokken meisje. Dit staat in schril contrast tot de spraakzame jonge vrouw die in 1965 toetrad tot de Kweekschool en daar voor het eerst haar schrijverstalent etaleerde. In 1969 werd ze leerkracht bij het Rooms Katholiek Bijzonder Onderwijs (RKBO). Op 22-jarige leeftijd trad ze toe tot de organisatie NAKS, een dan nog jonge maatschappelijke organisatie die sport en podiumkunsten als middel gebruikte om vormingswerk onder jongeren te bevorderen. In 2008 kreeg Elfriede, omdat zij langer dan 10 jaar aan de organisatie NAKS verbonden was tijdens een tak tangi deze pangi."
        },
        {
          id: 11,
          name: "Soekie Irodikromo",
          image: 129,
          type: 'open',
          person_image: '',
          text: "Sranan Krakti Soeki Irodikromo is een Surinaamse kunstenaar die geboren werd op 20 juni 1945 in het district Commewijne. Soeki studeerde beeldende kunst aan het Cultureel Centrum Suriname. Daarna is hij gaan studeren in Rotterdam, Nederland. Hij volgde de vrije opleiding schilderen en grafiek aan de Academie voor Beeldende Kunsten. Hij studeerde verder in Jogjakarta, Indonesia, aan de batik opleiding. Batik is een geweven katoenen stof decoreren met verf. Pa Soeki is na zijn vele studies teruggekeerd naar Suriname. Pa Soeki combineert Javaanse elementen in moderne kunst. Hij heeft als eerste Surinaams- Javaanse kunstenaar de traditie en moderniteit samen weten te brengen in zijn kunst. Hij is tevens de oprichter van de volksacademie Sana Budaya en introduceerde het batik schilderen in Suriname. Zowel zijn olie schilderijen als batik doeken zijn erg populair. Zijn werk is in de hele wereld terug te vinden."
        },
        {
          id: 12,
          name: "Monique Nouchiai",
          image: 113,
          type: 'open',
          person_image: '',
          text: "Sranan Krakti Monique Nouchiai is de dochter en de kleindochter van Libanese immigranten en ondernemers die zich vestigden in Suriname. Monique is opgeleid in management en bedrijfskunde. Zij begon haar carrière in 1989, toen zij en haar broer toetraden tot het familiebedrijf, dat bestond uit een eenmanszaak genaamd Readytex en een landbouwbedrijf met de naam Katwijk NV. Het familiebedrijf is inmiddels groter en georganiseerd onder de bestuurlijke en administratieve paraplu van de Caribbean Investment Group NV. Het bedrijf is verantwoordelijk voor het beheer en de administratie van Readytex NV, Katwijk NV, Carimega NV en Ricochet NV. Monique is gepassioneerd door mensen, creativiteit, 'reinvention', kennis en groei. Monique gelooft in de kracht van respect voor elkaar en schept voldoening in het bereiken van synergie in hetgeen dat zij doet. Een heks staat in de kunst vaak symbool voor een vrouw met kracht en kennis. Zij vond de heksenbezem een heel speciaal kado omdat het kwam van vrouwen die juist Monique bewondert om hun kracht en kennis."
        },
        {
          id: 13,
          name: "Anthony Nesty",
          image: 82,
          type: 'open',
          person_image: '',
          text: "Sranan Krakti Anthony Nesty is een Surinamer die het ver heeft gebracht met zwemmen. Naast het behalen van veel andere gouden medailles, behaalde Anthony Olympisch goud in 1988 en werd hij wereldkampioen in 1991 op de 100 meter vlinderslag. Anthony was 5 jaar toen hij begon met zwemlessen. Nadat hij al zijn zwemdiploma's had behaald, is hij begonnen met zwemtrainingen. Toen hij een paar wedstrijden won in Suriname en het Caribisch gebied werd hij steeds gemotiveerder. Op zijn 16de had hij de mogelijkheid om naar een goede 'highschool' en daarna naar een universiteit te gaan in Amerika waar er veel aandacht was voor het zwemmen. Anthony werd goed begeleid door zijn ouders. Anthony zegt dat als je wilt dat een Ferrari goed rijdt, je er goed voor moet zorgen en dat precies, hetzelfde voor je lichaam geldt. Na alle behaalde diploma's is Anthony zwemcoach geworden. In 2022 is Anthony Nesty hoofdcoach van de Amerikaanse WK-zwemploeg geworden."
        },
        {
          id: 14,
          name: "Gerrit Schouten",
          image: 81,
          type: 'closed',
          person_image: '',
          text: "Sranan Krakti Gerrit Carl François Schouten werd geboren in Paramaribo op 16 januari 1719 en overleed op 30 september 1839. Schouten was kunstenaar van beroep. Toen Gerard opgroeide was het in Suriname niet mogelijk een artistieke opleiding te volgen. Hij was dus autodidact. Schouten was een vakman op verschillende gebieden. Hij maakte studies van planten en dieren en tekende een enkele keer ook portretten. Daarnaast maakte hij plastisch werk: hij ontwierp een gedenkteken en vervaardigde tientallen diorama's die voor hoge bedragen verkocht werden. Bovendien prepareerde hij dieren, vooral vogels. Schouten maakte zijn werk voor verzamelaars, onderzoekers en wetenschappers. Schouten was de eerste creool in Suriname die naam maakte als kunstenaar. In Nederlandse musea bevinden zich diorama's van zijn hand, het dagelijks leven van inheemsen en marrons voorstellend. Hij ontving van het vorstenhuis een gouden medaille voor zijn verdiensten."
        },
        {
          id: 15,
          name: "Andre Loor",
          image: 100,
          type: 'open',
          person_image: '',
          text: "Sranan Krakti André Loor (Uitvlugt, 17 februari 1931 – Paramaribo, 10 december 2013) was een Surinaamse historicus. Andre Loor werd geboren in een ‘boeroe-gezin’. Boeroes zijn in Suriname wonende nazaten van Nederlandse arbeiders en boeren (boeroe = boer) die halverwege de 19e eeuw naar Suriname trokken. Loor heeft vele publicaties over de geschiedenis van Suriname en andere onderwerpen op zijn naam. Op 19 september 2013 presenteerde hij het boek 'André Loor vertelt...1850-1950', dat enthousiast werd ontvangen. Dit zou tevens zijn laatste werk zijn. Loor overleed op 82-jarige leeftijd. Op 18 december 2013 werd hij met staatseer begraven. Om de belangrijke rol van Loor voor de Surinaamse geschiedschrijving te benadrukken, komt hij in onze tentoonstelling voor. In 2012 is voor het gebouw van het Nationaal Archief Suriname aan de Mr. J. Lachmonstraat te Paramaribo een bronzen kopstuk van hem geplaatst."
        },
        {
          id: 16,
          name: "Monique Pool",
          image: 126,
          type: 'open',
          person_image: '',
          text: "Sranan Krakti Monique Pool van Green Heritage Fund heeft zich gewijd aan het helpen van wilde dieren in Suriname. Monique Pool zet zich al jaren in voor luiaards die vanwege ontbossing hun thuis verliezen. Ze heeft honderden luiaards en andere zoogdieren gered, gerehabiliteerd en weer vrijgelaten in het regenwoud. Zij beschermt luiaards en haar huis fungeert als een tijdelijk toevluchtsoord voor de zoogdieren. Voor deze liefdevolle daad krijgt zijn ondersteuning en erkenning en zo drong zij in 2015 door tot de laatste selectie van CNN Heroes."
        },
        {
          id: 17,
          name: "Jim Rasam",
          image: 49,
          type: 'open',
          person_image: '',
          text: "Sranan Krakti Jim Rasam is een geboren ondernemer uit de medische hoek en oprichter van het bedrijf Intermed. Rasam kan moeilijk stilzitten en ziet de hele wereld als één grote uitdaging. Van kinds af aan is de islam de toetssteen voor zijn dagelijks leven. Suriname is sinds 1996 lid van de Organisatie voor Islamitische Samenwerking (OIS). Suriname kan uitgroeien tot een financiële diensten- en handelscentrum voor de hele regio. En in dat streven is een centrale rol weggelegd voor de Trustbank Amanah waar Jim ook project director is. De Trustbank als één van de kleinste banken in Suriname, bevindt zich in een transformatieproces om het financiële hart en het financiële handelscentrum van Suriname te worden. Drs. J. Rasam, die ook eigenaar van Clevia Park is, merkt dat de gezondheid van de mensen steeds meer achteruit is gegaan. Het is om die reden dat Clevia Park is ontstaan. Clevia Park is een infotainment park gericht op een healthy lifestyle, informatie en entertainment."
        },
        {
          id: 18,
          name: "R. Dobru",
          image: 77,
          type: 'open',
          person_image: '',
          text: "Sranan Krakti Dobru (Paramaribo, 29 maart 1935 - 17 november 1983), pseudoniem van Robin Ewald Raveles, was een Surinaamse dichter, schrijver en politicus (Statenlid voor de PNR en na 1980 een half jaar onderminister voor Cultuur). Zijn pseudoniem betekent: dubbele R, een verwijzing naar de initialen van zijn voor- en achternaam. Dobru schreef altijd over twee vaste thema's: liefde en revolutie. Het bekendste gedicht uit zijn werk is zonder twijfel 'Wan Bon' (Één Boom in het Sranan), een gedicht waarin Dobru zijn hoop op één Surinaams volk uitdrukt. Aan de hand van verschillende metaforen beschrijft hij hoe Suriname weliswaar diverse bevolkingsgroepen kent, maar toch in staat zou moeten zijn één geheel te vormen. Het gedicht wordt nog regelmatig bij nationale gelegenheden voorgedragen en heeft een belangrijke symbolische functie binnen de Surinaamse literatuur ingenomen. Zijn poëzie en proza in het Sranan hebben er bovendien voor gezorgd dat Sranan meer als 'volwaardige taal' werd erkend. Dobru stimuleerde velen tot schrijven in het Sranan en Surinaams-Nederlands. 'Wan Bon' is in verschillende talen vertaald."
        },
        {
          id: 19,
          name: "Henk Tjon",
          image: 78,
          type: 'open',
          person_image: '',
          text: "Sranan Krakti Henk Tjon Tam Pau (Paramaribo, 25 augustus 1948 - 18 september 2009) was een Surinaams toneelschrijver en theatermaker. Tjon studeerde in Nederland voor regisseur en kwam nadien terecht bij de Haagse Comedy. Samen met onder meer Thea Doelwijt, maakte Tjon aan het einde van de jaren zestig het bekende cabaretprogramma ‘Land Te Koop’. In 1970 keerde hij terug naar Suriname en stichtte er in het begin van de jaren zeventig het Surinaamse Doe Theater op, samen met Thea Doelwijt. Tjons toneelstukken waren nationalistisch en sociaal kritisch van aard. Hij was tevens een van de organisatoren van Carifesta, het grootste kunstfestival van de Caraïben, dat afwisselend in een ander land plaatsvindt. Hij was ook de bedenker van de Alakondre dron (een drum-ensemble met muzikanten van verschillende Surinaamse achtergronden), waarvan Wilgo Baarn de dirigent was."
        },
        {
          id: 20,
          name: "Marcel Pinas",
          image: 79,
          type: 'open',
          person_image: '',
          text: "Sranan Krakti Marcel Pinas (Pelgrimkondre, Suriname, 22 maart 1971) is een Surinaamse kunstenaar van Marron- afkomst. Zijn geboortedorp ligt nabij Moengo, dat met het nabijgelegen Moiwana midden in het conflict van de Binnenlandse Oorlog stond (rond 1986). Deze afkomst speelt een belangrijke rol in het werk van Pinas, dat gaat over zijn eigen ervaringen in het verleden, maar ook over de vernietiging van de Marroncultuur in Suriname. Pinas studeerde aan de Nola Hatterman-kunstacademie (Suriname) van 1987 tot 1990. Zijn werk als kunstenaar werd in belangrijke mate bepaald in zijn studiejaren op Jamaica van 1997 tot 1999 aan het Edna Manley College of Visual and Performing Arts. En ook tijdens zijn studie op de Rijksacademie in Amsterdam (2007-2008). Pinas wil met zijn kunst een bijdrage leveren aan de toekomst van Suriname. Het hoofdthema in zijn werk is de cultuur van de Aukaners (Marron stam) waar hij van afstamt. Kibri a Kulturu (behoed onze cultuur) is de drijvende kracht achter zijn werk."
        },
        {
          id: 21,
          name: "Richard Cullimore",
          image: 108,
          type: 'closed',
          person_image: '',
          text: "Sranan Krakti Richard Cullimore is een traditionele Surinaamse natuurgenezer. Hij heeft de hele wereld over gereisd en heeft o.a. in Nederland, Amerika, China en Indonesië gestudeerd. Zijn gave en zijn brede kennis van natuurgeneeswijze hebben hem diverse prijzen op dit gebied opgeleverd, waaronder die van World Best Healer (6x) en European Best Healer(8x). Tevens heeft hij een gouden bloem, een titel die wordt uitgereikt aan mensen die ingewijd zijn in Indonesische traditionele geneeskunde. Na een periode in Dubai gewerkt te hebben, is hij nu gevestigd in Suriname, waar hij bereikbaar is voor consulten, maar ook enkele studenten begeleidt. Tientallen jaren geleden op het platteland van Suriname leerde Richard Cullimore de geheimen van natuurgenezing van zijn grootvader. Cullimore groeide uit tot een van de beste natuurgenezers in het land. Op dit moment behoort Cullimore tot de top van natuurgenezers in de wereld en heeft twee keren zelfs met de hoogste eer gestreken; namelijk beste natuurgenezer ter wereld."
        },
        {
          id: 22,
          name: "Indra Hu",
          image: 80,
          type: 'closed',
          person_image: '',
          text: "Indra Ramdas is geboren in Paramaribo op 24 februari 1973. Indra Hu is haar aangetrouwde naam die zij ook gebruikt als schrijver. Van kleins af aan ben is Indra geïntrigeerd door alles wat blijdschap en geluk uitstraalt. Zij las veel sprookjes en vertelde de verhalen met veel enthousiasme aan haar jongere zusjes, neven en nichten. Indra’s passie voor het vertellen is overgewaaid in het schrijven toen zij haar eigen kinderen kreeg. Indra schrijft, omdat het haar blij maakt en omdat zij de kinderen door haar schrijven die blijheid wil doorgeven. In 2002 debuteerde zij met haar kinderboek De avonturen van Leena en Jopie- Leena en Jopie ontmoeten Sisi, de luie poes als kinderboekenschrijfster. In 2012 debuteerde zij als jeugdboekenschrijfster met het boek: Laat mij niet alleen, waarmee zij werd uitgeroepen tot schrijver van het jaar. Anno 2022, twintig jaren later, is Indra de trotse jeugd- en kinderboekenschrijfster van wel 26 werken; van gedrukte boeken tot audio- en visuele werken voor zowel kinderen zonder een beperking als kinderen met een beperking. Indra kreeg het paverpol kunstwerk toen zij 14 jaar schrijfster wasij vindt dit een bijzonder cadeau van een bijzonder getalenteerd mens en zal het voor altijd blijven koesteren.r schrijver was in 2016."
        },
      ]
    };
  },

  methods: {
    goToHome() {
      this.$router.push('/');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: true,
          show_start_selector_overlay: false,
      });
    },
    goToStartPage(itemObj) {
      this.$router.push('/start');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: false,
          show_start_selector_overlay: true,
      });
      
      this.$store.dispatch('app/asyncUpdateContent', itemObj);
    },
    checkLandscape() {
      if ( window.innerWidth < ( window.innerHeight * 1.5 ) ) {
        if ( ! this.$store.getters['app/overlays'].show_landscape_error )
          this.$store.dispatch('app/asyncUpdateLandscapeOverlay', {
            show_landscape_error: true
          });
      } else {
        if ( this.$store.getters['app/overlays'].show_landscape_error )
          this.$store.dispatch('app/asyncUpdateLandscapeOverlay', {
            show_landscape_error: false
          });
      }
    }
  },

  computed: {},

  watch: {}
}
</script>

<style>
  @font-face {
    font-family: "LuckiestGuy";
    src: url('./assets/fonts/LuckiestGuy-Regular.ttf') format('truetype');
  }

  .landscape_error {
    background-color: grey;
    width: 105%;
    height: 105%;
    position: absolute;
    z-index: 3;
  }

  #text_error {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 25%;
    color: white;
    width: 95%;
    font-size: 5.5vw;
    text-align: center;
  }

  #main_image_83 {
    position: absolute;
    margin-top: 7.4%;
    z-index: 0;
    left: 15%;
    width: 5%;
  }
  #main_image_111 {
    position: absolute;
    margin-top: 7.4%;
    z-index: 0;
    left: 40%;
    width: 4%;
  }
  #main_image_128 {
    position: absolute;
    margin-top: 14.7%;
    z-index: 0;
    left: 8.5%;
    width: 7%;
  }
  #main_image_107 {
    position: absolute;
    margin-top: 14.7%;
    z-index: 0;
    left: 23%;
    width: 1.5%;
  }
  #main_image_130 {
    position: absolute;
    margin-top: 14.7%;
    z-index: 0;
    left: 34%;
    width: 3.5%;
  }
  #main_image_112 {
    position: absolute;
    margin-top: 14.6%;
    z-index: 0;
    left: 46.7%;
    width: 2.5%;
  }
  #main_image_76 {
    position: absolute;
    margin-top: 22%;
    z-index: 0;
    left: 10.5%;
    width: 1.5%;
  }
  #main_image_109 {
    position: absolute;
    margin-top: 22%;
    z-index: 0;
    left: 21%;
    width: 5.5%;
  }
  #main_image_102 {
    position: absolute;
    margin-top: 21.8%;
    z-index: 0;
    left: 33%;
    width: 5.5%;
  }
  #main_image_1 {
    position: absolute;
    margin-top: 22%;
    z-index: 0;
    left: 44%;
    width: 9%;
  }
  #main_image_129 {
    position: absolute;
    margin-top: 29%;
    z-index: 0;
    left: 10%;
    width: 3%;
  }
  #main_image_113 {
    position: absolute;
    margin-top: 30.5%;
    z-index: 0;
    left: 19.4%;
    width: 9%;
  }
  #main_image_82 {
    position: absolute;
    margin-top: 29%;
    z-index: 0;
    left: 33.5%;
    width: 4.5%;
  }
  #main_image_81 {
    position: absolute;
    margin-top: 29%;
    z-index: 0;
    left: 46%;
    width: 4.5%;
  }
  #main_image_100 {
    position: absolute;
    margin-top: 36%;
    z-index: 0;
    left: 9.6%;
    width: 4.5%;
  }
  #main_image_126 {
    position: absolute;
    margin-top: 35.6%;
    z-index: 0;
    left: 21.7%;
    width: 4.5%;
  }
  #main_image_49 {
    position: absolute;
    margin-top: 36%;
    z-index: 0;
    left: 33.5%;
    width: 4.5%;
  }
  #main_image_77 {
    position: absolute;
    margin-top: 36%;
    z-index: 0;
    left: 46.5%;
    width: 3.6%;
  }
  #main_image_78 {
    position: absolute;
    margin-top: 43%;
    z-index: 0;
    left: 10.5%;
    width: 2%;
  }
  #main_image_79 {
    position: absolute;
    margin-top: 43%;
    z-index: 0;
    left: 22.3%;
    width: 3.5%;
  }
  #main_image_108 {
    position: absolute;
    margin-top: 43%;
    z-index: 0;
    left: 35%;
    width: 3.6%;
  }
  #main_image_80 {
    position: absolute;
    margin-top: 43%;
    z-index: 0;
    left: 46.6%;
    width: 3%;
  }

  #quit_btn {
    position: absolute;
    margin-top: 5%;
    right: 3%;
    width: 15%;
    z-index: 1;
  }

  .background_image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
  }

  #text_1 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 9%;
    width: 20%;
    left: 8%;
    font-size: 1.5vw;
    text-align: center;
    color: white;
  }

  #text_2 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 9%;
    width: 20%;
    left: 32%;
    font-size: 1.5vw;
    text-align: center;
    color: white;
  }

  #text_3 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 16.5%;
    width: 8%;
    left: 8%;
    font-size: 1.5vw;
    text-align: center;
    color: white;
  }

  #text_4 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 23%;
    width: 11.5%;
    left: 6%;
    font-size: 1.5vw;
    text-align: center;
    color: white;
  }
  #text_5 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 30%;
    width: 11.5%;
    left: 6%;
    font-size: 1.5vw;
    text-align: center;
    color: white;
  }
  #text_6 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 37%;
    width: 11.5%;
    left: 6%;
    font-size: 1.5vw;
    text-align: center;
    color: white;
  }
  #text_7 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 45.2%;
    width: 11.5%;
    left: 6%;
    font-size: 1.5vw;
    text-align: center;
    color: white;
  }

  #text_8 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 16%;
    width: 8%;
    left: 20%;
    font-size: 1.5vw;
    text-align: center;
    color: white;
  }

  #text_9 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 24%;
    width: 11.5%;
    left: 18%;
    font-size: 1.5vw;
    text-align: center;
    color: white;
  }
  #text_10 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 30.5%;
    width: 11.5%;
    left: 18.1%;
    font-size: 1.4vw;
    text-align: center;
    color: white;
  }
  #text_11 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 37%;
    width: 11.5%;
    left: 18.2%;
    font-size: 1.5vw;
    text-align: center;
    color: white;
  }
  #text_12 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 44.3%;
    width: 11.5%;
    left: 18%;
    font-size: 1.5vw;
    text-align: center;
    color: white;
  }
  #text_13 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 16.5%;
    width: 12%;
    left: 29.9%;
    font-size: 1.5vw;
    text-align: center;
    color: white;
  }

  #text_14 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 23%;
    width: 11.5%;
    left: 30%;
    font-size: 1.5vw;
    text-align: center;
    color: white;
  }
  #text_15 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 30.9%;
    width: 11.5%;
    left: 30%;
    font-size: 1.5vw;
    text-align: center;
    color: white;
  }
  #text_16 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 37.5%;
    width: 11.5%;
    left: 30%;
    font-size: 1.5vw;
    text-align: center;
    color: white;
  }
  #text_17 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 45.2%;
    width: 11.5%;
    left: 30%;
    font-size: 1.5vw;
    text-align: center;
    color: white;
  }
  #text_18 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 16.5%;
    width: 8%;
    left: 44%;
    font-size: 1.5vw;
    text-align: center;
    color: white;
  }

  #text_19 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 23.8%;
    width: 7.5%;
    left: 44.5%;
    font-size: 1.5vw;
    text-align: center;
    color: white;
  }
  #text_20 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 30.9%;
    width: 11.5%;
    left: 42.6%;
    font-size: 1.5vw;
    text-align: center;
    color: white;
  }
  #text_21 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 37.2%;
    width: 11.5%;
    left: 42.5%;
    font-size: 1.5vw;
    text-align: center;
    color: white;
  }
  #text_22 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 45.2%;
    width: 11.5%;
    left: 42.5%;
    font-size: 1.5vw;
    text-align: center;
    color: white;
  }
  

  body {
    cursor: url('./assets/cursor/material-wood-cursor.png'), default;	
  }

  #start_btn {
    cursor: url('./assets/cursor/material-wood-pointer.png'), default;	
    position: absolute;
    margin-top: 17%;
    left: 30%;
    width: 20%;
  }

  .clickable:hover {
    opacity: 0.7;
    cursor: url('./assets/cursor/material-wood-pointer.png'), default;	
  }

  #logo {
    position: absolute;
    margin-top: 17%;
    left: 60%;
    width: 35%;
    z-index: 0;
  }

  #closet {
    position: absolute;
    margin-top: 4%;
    left: 5%;
    width: 50%;
    z-index: 0;
  }

  body {
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
  }
</style>
